import { Component, Input } from '@angular/core';

import { CardComponent } from '../card/card.component';

@Component({
  selector: 'bn-web-ui-step-card',
  templateUrl: './step-card.component.html',
  imports: [CardComponent],
})
export class StepCardComponent {
  @Input()
  public heading = '';

  @Input()
  public number!: number;

  @Input()
  public isFullHeight = true;

  @Input()
  public isHoverable = false;

  @Input()
  public hasPadding = true;

  @Input()
  public isRounded = false;

  @Input()
  public disableContent = false;

  @Input()
  public isLoading = false;

  @Input()
  public noShadow = false;

  @Input()
  public noBorder = false;
}
